// import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'react-awesome-button/dist/styles.css';
import { AwesomeButton } from 'react-awesome-button';
import { FaGithub, FaLinkedin} from "react-icons/fa";
import { SiGmail} from "react-icons/si";

import '../styles/Contato.css';

export default class Contato extends Component {

  render() {
    return (
      <section id="contato" className="container-contato animate__animated animate__slideInUp">
        <h3>Contato</h3>
        <div className="container-link animate__animated animate__bounce animate__repeat-3	3">
        <AwesomeButton size="medium" type="github"><a href="https://github.com/AlessandraRomualdo" target="_blank" rel="noreferrer"><FaGithub /></a></AwesomeButton>

        <AwesomeButton size="medium" type="github"><a href="https://www.linkedin.com/in/alessandra-romualdo/" target="_blank" rel="noreferrer"><FaLinkedin/></a></AwesomeButton>

        <AwesomeButton size="medium" type="github">
        <a href = "mailto:contato@alessandra.romualdo.dev@gmail.com" target="_blank" rel="noreferrer"><SiGmail/></a>
        </AwesomeButton>

        </div>
        <p className="paragraph-footer">Desenvolvido por Alessandra Romualdo ❤ 2023</p>
      </section>
    )
  };
};